import { ScrollArea } from '@/components/ui';
import { SquareLibrary } from 'lucide-react';
import { CollectionList } from '../collection-list';
import { useSidebar } from './use-sidebar';

export function Sidebar(props: Parameters<typeof useSidebar>[0]) {
  const f = useSidebar(props);

  return (
    <div className="h-full flex flex-col border-r bg-card">
      <div className="p-4 border-b">
        <h2 className="text-lg font-semibold flex items-center">
          <SquareLibrary className="h-5 w-5 mr-2" />
          Collections
        </h2>
      </div>
      <ScrollArea className="flex-1">
        <div className="p-2">
          <CollectionList
            collections={f.allCollections}
            loading={f.loading}
            selectedCollection={f.selectedCollection}
            onSelectCollection={f.onSelectCollection}
          />
        </div>
      </ScrollArea>
    </div>
  );
}
